import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const FundView = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Manual Adjustment Modal State
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [adjustType, setAdjustType] = useState("credit");
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/wallets/summary`);
      setData(res.data);
    } catch (err) {
      console.error("Error fetching admin wallet summary", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  const handleAdjustSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setSubmitting(true);

    try {
      const userId = selectedWallet.userId?._id || selectedWallet.userId;
      const res = await axios.post(`${API_BASE_URL}/api/admin/users/${userId}/wallet-adjust`, {
        type: adjustType,
        amount: Number(amount),
        notes,
      });

      setMessage(res.data.message);
      setAmount("");
      setNotes("");
      await fetchSummary();
      setTimeout(() => setSelectedWallet(null), 1500);
    } catch (err) {
      setError(err.response?.data?.message || "Adjustment failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ margin: 0, color: "#fff" }}>Fund View & Management</h2>
        <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
          Platform-wide virtual capital management, total margin exposure, and client wallet adjustments
        </p>
      </div>

      {/* Aggregate Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px", marginBottom: "24px" }}>
        <div style={cardStyle}>
          <div style={cardLabelStyle}>Total Virtual Platform Funds</div>
          <div style={{ fontSize: "22px", fontWeight: "bold", color: "#4caf50", marginTop: "6px" }}>
            ₹{data?.summary?.totalPlatformBalance?.toLocaleString('en-IN') || '0.00'}
          </div>
        </div>

        <div style={cardStyle}>
          <div style={cardLabelStyle}>Total Margin Exposure</div>
          <div style={{ fontSize: "22px", fontWeight: "bold", color: "#ff9800", marginTop: "6px" }}>
            ₹{data?.summary?.totalMarginUsed?.toLocaleString('en-IN') || '0.00'}
          </div>
        </div>

        <div style={cardStyle}>
          <div style={cardLabelStyle}>Total Platform Deposits</div>
          <div style={{ fontSize: "22px", fontWeight: "bold", color: "#2962ff", marginTop: "6px" }}>
            ₹{data?.summary?.totalDeposits?.toLocaleString('en-IN') || '0.00'}
          </div>
        </div>

        <div style={cardStyle}>
          <div style={cardLabelStyle}>Total Withdrawals</div>
          <div style={{ fontSize: "22px", fontWeight: "bold", color: "#ab47bc", marginTop: "6px" }}>
            ₹{data?.summary?.totalWithdrawals?.toLocaleString('en-IN') || '0.00'}
          </div>
        </div>
      </div>

      {/* Wallets Table */}
      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        <div style={{ padding: "16px", borderBottom: "1px solid #2a2e39", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, color: "#fff", fontSize: "16px" }}>Client Virtual Wallets ({data?.wallets?.length || 0})</h3>
          <button onClick={fetchSummary} style={btnStyle}>Refresh Wallets</button>
        </div>

        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Loading wallets...</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Client Name</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>KYC Status</th>
                <th style={thStyle}>Virtual Balance</th>
                <th style={thStyle}>Margin Available</th>
                <th style={thStyle}>Margin Used</th>
                <th style={thStyle}>Total Deposits</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(data?.wallets || []).map((w) => {
                const clientUser = w.userId || {};
                return (
                  <tr key={w._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                    <td style={{ ...tdStyle, fontWeight: "bold", color: "#fff" }}>{clientUser.name || "N/A"}</td>
                    <td style={tdStyle}>{clientUser.email || "N/A"}</td>
                    <td style={tdStyle}>
                      <span
                        style={{
                          padding: "2px 8px",
                          borderRadius: "10px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          backgroundColor: clientUser.kycStatus === "verified" ? "rgba(76, 175, 80, 0.15)" : "rgba(255, 152, 0, 0.15)",
                          color: clientUser.kycStatus === "verified" ? "#4caf50" : "#ff9800",
                        }}
                      >
                        {clientUser.kycStatus?.toUpperCase()}
                      </span>
                    </td>
                    <td style={{ ...tdStyle, fontWeight: "bold", color: "#4caf50" }}>
                      ₹{w.virtualBalance?.toLocaleString('en-IN')}
                    </td>
                    <td style={tdStyle}>₹{w.marginAvailable?.toLocaleString('en-IN')}</td>
                    <td style={tdStyle}>₹{w.marginUsed?.toLocaleString('en-IN')}</td>
                    <td style={tdStyle}>₹{w.totalDeposits?.toLocaleString('en-IN')}</td>
                    <td style={tdStyle}>
                      <button
                        onClick={() => {
                          setSelectedWallet(w);
                          setMessage("");
                          setError("");
                        }}
                        style={adjustBtnStyle}
                      >
                        ⚡ Credit / Debit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Adjustment Modal */}
      {selectedWallet && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>
              Adjust Virtual Wallet: {selectedWallet.userId?.name}
            </h3>
            <p style={{ fontSize: "13px", color: "#b2b5be" }}>
              Manually top-up or debit virtual paper-trading capital. All changes will be logged in system audit trail.
            </p>

            {message && <div style={{ backgroundColor: "rgba(76, 175, 80, 0.2)", color: "#81c784", padding: "10px", borderRadius: "4px", marginBottom: "12px", fontSize: "13px" }}>{message}</div>}
            {error && <div style={{ backgroundColor: "rgba(239, 83, 80, 0.2)", color: "#ff8a80", padding: "10px", borderRadius: "4px", marginBottom: "12px", fontSize: "13px" }}>{error}</div>}

            <form onSubmit={handleAdjustSubmit}>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Adjustment Action</label>
                <select value={adjustType} onChange={(e) => setAdjustType(e.target.value)} style={inputStyle}>
                  <option value="credit">➕ Credit Virtual Balance (Top-Up)</option>
                  <option value="debit">➖ Debit Virtual Balance</option>
                </select>
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Amount (₹)</label>
                <input
                  type="number"
                  min="1"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="e.g. 50000"
                  required
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Mandatory Reason / Audit Note</label>
                <input
                  type="text"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="e.g. Demo balance top-up requested by client"
                  required
                  style={inputStyle}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                <button type="button" onClick={() => setSelectedWallet(null)} style={cancelBtnStyle}>Cancel</button>
                <button type="submit" disabled={submitting} style={btnStyle}>
                  {submitting ? "Processing..." : "Confirm Adjustment"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const cardStyle = {
  backgroundColor: "#1e222d",
  padding: "18px",
  borderRadius: "8px",
  border: "1px solid #2a2e39",
};

const cardLabelStyle = {
  fontSize: "12px",
  color: "#b2b5be",
  textTransform: "uppercase",
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

const btnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

const adjustBtnStyle = {
  padding: "6px 12px",
  backgroundColor: "#2a2e39",
  color: "#4caf50",
  border: "1px solid #4caf50",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: "bold",
};

const cancelBtnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2a2e39",
  color: "#fff",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalContentStyle = {
  backgroundColor: "#2a2e39",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "460px",
  color: "#fff",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: 500,
  marginBottom: "6px",
  color: "#d1d4dc",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #434651",
  backgroundColor: "#1e222d",
  color: "#fff",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default FundView;
